import {app} from '../app';

/**
 * Filter that converts normal string to slug.
 * E.g. "hello World" => "hello-world"
 */
app.filter('slugify', [function () {
    return (input) => {
        return input.toLowerCase()
            .replace(/\s+/g, '-')           // Replace spaces with -
            .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
            .replace(/\-\-+/g, '-')         // Replace multiple - with single -
            .replace(/^-+/, '')             // Trim - from start of text
            .replace(/-+$/, '');            // Trim - from end of text
    };
}]);